import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dateToString } from '../shared/formatters';
import { loadingStart, loadingEnd, showMessage } from './appMainSlice';
import { logoff } from './accountSlice';

var today = new Date();
const initialState = {
  result: {},
  shouldBeUpdated: true,
  lastUpdate: today.toISOString(),
  showFilters: window.innerWidth > 600,
  filterFields: {
    description: '',
    categories: [],
    groups: [],
    financeAccounts: [],
    users: [],
    from: dateToString(new Date(today.getFullYear(), 0, 1)),
    to: dateToString(new Date(today.getFullYear(), today.getMonth() + 1, 0))
  }
};

// Async thunks
export const loadStart = createAsyncThunk(
  'balancePerCategory/loadStart',
  async (_, { dispatch, getState, extra: api }) => {
    dispatch(loadingStart());
    try {
      const filters = getState().balancePerCategory.filterFields;
      const result = await api.loadBalancePerCategory(filters);
      dispatch(loadingEnd());
      return result;
    } catch (error) {
      dispatch(loadingEnd());
      if (error.isAxiosError) {
        dispatch(logoff());
        throw error;
      }
      dispatch(showMessage(error));
      throw error;
    }
  }
);

const balancePerCategorySlice = createSlice({
  name: 'balancePerCategory',
  initialState,
  reducers: {
    updateFilters: (state, action) => {
      state.shouldBeUpdated = true;
      state.showFilters = true;
      state.filterFields = { ...action.payload };
    },
    toogleFilters: (state) => {
      state.showFilters = !state.showFilters;
    },
    clear: () => {
      return initialState;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadStart.pending, (state) => {
        state.shouldBeUpdated = false;
        state.lastUpdate = new Date().toISOString();
      })
      .addCase(loadStart.fulfilled, (state, action) => {
        state.result = action.payload;
        state.shouldBeUpdated = false;
        state.lastUpdate = new Date().toISOString();
      })
      .addCase(loadStart.rejected, (state) => {
        state.shouldBeUpdated = true;
      });
  }
});

export const { updateFilters, toogleFilters, clear } = balancePerCategorySlice.actions;

export default balancePerCategorySlice.reducer;
